module.exports = __webpack_public_path__ + "static/img/mazzo-di-carte-1.9cb150f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mazzo-di-carte-1.svg
// module id = LAnF
// module chunks = 1